import { AnalyticsEvent } from "@services/tracking/types/analyticsEvent";

import EventDataLayer from "../../queue/EventDataLayer";
import { SubscriberCallback } from "../../queue/SubscriberCallback";
import { processBazaarVoiceOrderConfirmation } from "./mappers/BazaarVoiceOrderConfirmationImpression";

const BazaarVoiceSubscriber = (
    eventDataLayer: EventDataLayer,
    withHistory = false,
) => {
    eventDataLayer.subscribe("bazaarvoice-subscriber", subscribe, withHistory);
};

const subscribe: SubscriberCallback = (
    event: string,
    data: AnalyticsEvent,
): void => {
    switch (event) {
        case "tool-laststep":
            processBazaarVoiceOrderConfirmation(data);
            break;
    }
};

export { BazaarVoiceSubscriber };
